import React from 'react';
import { ChildProfileManager } from './ChildProfileManager';
import { useNavigate } from 'react-router-dom';
import { useSettings } from '../../hooks/queries/useSettings';
import { GamePageWrapper } from '../GameLayout';
import { CLOCK_THEMES } from '../../styles/clockThemes';
import styles from './Profile.module.scss';

export const ProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const { settings } = useSettings();
  
  // Get current theme
  const currentTheme = CLOCK_THEMES[settings?.clockThemeId || 'playful_focus'] || CLOCK_THEMES['playful_focus'];

  return (
    <GamePageWrapper title="👤 Profile & Children">
      <div className={styles.pageContent}>
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Parent Account</h2>
          <div className={styles.card}>
            <div className={styles.buttonRow}>
              <button 
                onClick={() => navigate('/update-password')}
                className={styles.actionBtn}
              >
                Change Password
              </button>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Manage Children</h2>
          <ChildProfileManager 
            themeColors={{
              textColor: currentTheme.colors.textColor,
              accentColor: currentTheme.colors.accentColor,
              secondaryText: currentTheme.colors.secondaryText
            }}
          />
        </div>
      </div>
    </GamePageWrapper>
  );
};
